import React, {PureComponent} from 'react';
import cn from "classnames"
import universal from "react-universal-component"
import injectSheet from 'react-jss'
import { connect } from 'react-redux'
import { NOT_FOUND } from "redux-first-router"
import NotFound from "./NotFound"
import TransitionGroup from 'react-transition-group/TransitionGroup';
import Transition from 'react-transition-group/Transition';
import {getCurrentPageContent, getCurrentLocation, getArticles, isUsingUniversalMenu, getUniversalMenuIsOpen, getUniversalMenuAccountMenuIsOpen} from "../selectors"
import {canUseDom} from "../utils/dom"
import LandingPage from './LandingPage'
import Search from './Search'
import first from "lodash/first"
import get from "lodash/get"

const Loading = () => <div></div>
const TRANSITION_DURATION_SECONDS = 0.3;

const components = {
    today_landing_page: (props) => <LandingPage {...props} />,
    landing_page: (props) => <LandingPage {...props} />,
    lookbooks_landing_page: (props) => <LandingPage {...props} />,
    article: universal(() => import(/* webpackChunkName: 'article' */ './Article'), {
        resolve: () => require.resolveWeak('./Article'),
        chunkName: 'article',
        minDelay: 0,
        loading: Loading
    }),
    lookbook:  universal(() => import(/* webpackChunkName: 'article' */ './Lookbook'), {
        resolve: () => require.resolveWeak('./Lookbook'),
        chunkName: 'article',
        minDelay: 0,
        loading: Loading
    }),
    search: (props) => <Search {...props} />
}

class PageContent extends PureComponent {

    componentWillMount() {
        components["article"].preload();
    }

    _updateScroll = () => {
        if(!canUseDom) return;
        // This uses the session storage that is setup by the redux-first-router-restore-scroll package
        // We need to set this to manual as we are doing some transitions between pages
        var key = get(window, ['history', 'state', 'key']);
        if(!key) key = 'loadPage';
        const valueString = window.sessionStorage.getItem(`@@scroll|${key}`);
        if(valueString) {
            const value = JSON.parse(valueString);
            window.scrollTo(value[0], value[1]);
        }
        else {
            window.scrollTo(0, 0);
        }
    }

    _onExiting = (node) => {
        const {universalMenu} = this.props;
        if(universalMenu) {
            const header = first(document.getElementsByTagName("header"));
            if(header)
                node.style.marginTop = `${header.clientHeight}px`;
        }
    }

    _onEntering = (node) => {
        this._updateScroll();
    }

    render() {
        const {classes, page, notFound, articles, universalMenu, isUniversalNavOpen, isUniversalNavAccountMenuOpen} = this.props;
        if(notFound) return <NotFound />
        if(!page) return null;
        const Component = components[page.type] || NotFound

        return <TransitionGroup appear={true} enter={true} exit={true}>
            <Transition timeout={TRANSITION_DURATION_SECONDS*1000}
                        onEntering={this._onEntering}
                        onExiting={this._onExiting}
                        key={page.slug} >
                {(state) => (
                    <div className={cn(classes.page, {
                        [classes.universalNavOpen]: isUniversalNavOpen || isUniversalNavAccountMenuOpen,
                        [classes.pageWithEditionMenu]: !universalMenu,
                        [classes.pageWithUniversalMenu]: universalMenu,
                        pageExiting: state === 'exiting'
                    })}>
                        <Component page={page} articles={articles}/>
                    </div>
                )}
            </Transition>
        </TransitionGroup>;
    }
}

const mapStateToProps = (state) => {
    return {
        page: getCurrentPageContent(state),
        location: getCurrentLocation(state),
        notFound: state.location.type === NOT_FOUND,
        articles: getArticles(state),
        universalMenu: isUsingUniversalMenu(state),
        isUniversalNavOpen: getUniversalMenuIsOpen(state),
        isUniversalNavAccountMenuOpen: getUniversalMenuAccountMenuIsOpen(state),
    }
}

const getWindowScrollY = () => {
    return canUseDom ? window.pageYOffset : 0
}

export default connect(mapStateToProps)( injectSheet(theme => ({
    page: {
        transition: `opacity ${TRANSITION_DURATION_SECONDS}s ${theme.animation.easing.accelerationCurve}`,
        backgroundColor: theme.colors.white,
        '&.pageExiting': {
            position: "fixed",
            overflow: "hidden",
            left: 0,
            width: "100%",
            top: () => -getWindowScrollY(),
            height: () => `calc(100vh + ${getWindowScrollY()}px)`,
            opacity: 0,
        }
    },
    pageWithEditionMenu: {
        ...theme.header.height('marginTop'),
    },
    pageWithUniversalMenu: {
        marginTop: 0,
        '&.pageExiting': {
        }
    },
    universalNavOpen: {
        display: 'none',
        [theme.breakpoint('laptop')]: {
            display: 'block',
        }
    }
}))(PageContent) );



// WEBPACK FOOTER //
// ./src/components/PageContent.js